export const SCORE_MIN_TEXT_WIDTH = 34;

export const pixels = (num: number) => `${num}px`;
